import { authHeader } from "../helpers/auth-header";
import axios from 'axios';

const getList = () => {
    return axios.get(`/api/maps`, { headers: authHeader() })
        .then(res => {
            return res.data;
        });
};

const addHotspot = (hotspotModel) => {
    return axios.post(`/api/maps/CreateHotspot/${hotspotModel.roomId}`, hotspotModel, { headers: authHeader() } )
        .then(res => {
            return res.data
        });
};

const editHotspot = (hotspotModel) => {
    // change to patch
    return axios.patch(`/api/maps/EditHotspot/${hotspotModel.id}`, hotspotModel, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const deleteHotspot = (id) => {
    return axios.delete(`/api/maps/DeleteHotSpot/${id}`, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const addMapConfig = (mapModel) => {
    delete mapModel['id'];
    return axios.post(`/api/maps/CreateMap`, mapModel, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const editMapConfig = (mapModel) => {
    return axios.patch(`/api/maps/EditMap/${mapModel.id}`, mapModel, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const deleteMapConfig = (id) => {
    return axios.delete(`/api/maps/DeleteMap/${id}`, { headers: authHeader() })
        .then(res => {
            return res.data
        });
};

const uploadMap = (formData) => {
    return axios.post(`/api/maps/uploadmap`, formData, { headers: authHeader() } )
        .then((res) => {
                return res.data
            }
        );
};

export const exhibitionMapService = {
    getList,
    addHotspot,
    editHotspot,
    deleteHotspot,
    addMapConfig,
    editMapConfig,
    deleteMapConfig,
    uploadMap
};
